import { useMutation } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';

interface Params {
  quoteId: string;
  payload: Payload;
}

interface Payload {
  action_url: string;
  emails: string[];
  last_name?: string;
  initials?: string;
  gender?: string;
}

const sendCalculation = async ({ payload, quoteId }: Params) => {
  const { data, isError } = await wgApi.post(
    `v1/api/quotes/${quoteId}/email-inquiries`,
    payload,
  );
  if (isError) throw new Error();
  return data;
};

export const useSendCalculation = () => {
  return useMutation(sendCalculation);
};
